import styled from 'styled-components';
import NextImage from 'next/image';

export default styled(NextImage)`
  height: 100%;
  width: 100%;
`;
